import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const ProductDetailsBottom = ({ productItem }) => {
  const prodDescRef = useRef();
  useEffect(() => {
    // prodDescRef.current.innerHTML = productItem?.description;
    prodDescRef.current.innerHTML = productItem.description;
  }, [productItem]);
  return (
    <div>
      <h1 className="text-xl font-bold font-sans ">Short Description : </h1>
      <div className="my-4 description-output " ref={prodDescRef}></div>

      <div>
        <Link to={"/reviews"}>
          <button className="site-btn px-2 py-4">
            Give A review <i className="fa fa-star " aria-hidden="true"></i>
          </button>
        </Link>
      </div>
    </div>
  );
};

export default ProductDetailsBottom;
